<template>
  <xm-page>
    <div class="empty-data-page">
      <div v-if='!onLoading'>
        <img :src="src">
        <div class="tips" v-html="title"></div>
      </div>
      <xm-spin v-else fix v-show="spin.show">
      <svg class="circular"
            viewBox="25 25 50 50">
        <circle class="path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke-width="5"
                stroke-miterlimit="10"></circle>
      </svg>
    </xm-spin>
    </div>
  </xm-page>
</template>

<script>
export default {
  name: 'xm-empty-page',
  props: {
    title: String,
    src: String,
    onLoading: true
  },
  data() {
    return {
      spin: {}
    }
  }
};
</script>

<style lang="less">

@import '../../core/variables.less';

.empty-data-page {
  background-color: #F4F6FA;
  height: 100%;
  justify-content: center;
  font-size: 0.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 2rem;
  }
  .tips {
    border: none;
    font-size: 0.26rem;
    background-color: transparent;
    padding-top: 0.6rem;
    color: #999999;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/module/base/EmptyDataPage.vue